import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const techRegulationsApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'techRegulationsApi',
  endpoints: (builder) => ({
    getTechRegulations: builder.query<TechRegulationsItem[], string>({
      query: (query) => `certification/v4.0/tech_regulations/`,
    }),
  }),
})

export const techRegulationsSlice = createSlice({
  name: 'techRegulations',
  initialState: {
    techRegulations: [] as TechRegulationsItem[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      techRegulationsApi.endpoints.getTechRegulations.matchFulfilled,
      (state, { payload }) => {
        state.techRegulations = payload
      }
    );
  },
})

export const { useLazyGetTechRegulationsQuery } = techRegulationsApi

export const useTechRegulations = () => {
  return useSelector(({ techRegulations }: ReturnType<typeof rootReducer>) => techRegulations.techRegulations)
}
